// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateSendgridSetting_createButton__3GEal"};